export const COMPANY_NAME = "DesignedVR";
export const LOGO = "logo.png";
export const LOGO_WHITE = "white-logo.png";
export const BACKDROP = "backdrop.png";
export const IMAGE_PLACEHOLDER = "image-placeholder.jpg";
export const HOME_TITLE = "home_title";
export const HOME_SUBTITLE = "home_subtitle";
export const HOME_LISTINGS_TITLE = "exactly_what_you_are_looking_for";
export const HOME_TOP_DESTINATIONS_TITLE = "most_popular_destinations";
export const HOME_TOP_DESTINATIONS_BUTTON_TEXT = "View all destinations";
export const HOME_FEATURES_TITLE = "what_makes_us_different";
export const HOME_REVIEWS_TITLE = "what_our_guests_are_saying";
export const HOME_TRIGGER_TITLE = "ready_to_go";
export const HOME_TRIGGER_SUBTITLE = "home_trigger_subtitle";
export const FOOTER_DESCRIPTION =
  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.";
export const FOOTER_FORM_TITLE = "stay_in_the_loop";
export const FOOTER_FORM_DESCRIPTION =
  "Keep up with our featured homes, new locations, and travel tips! Oh, and get $100 off your first stay with us.";
export const FOOTER_FORM_SUBTITLE = "footer_form_subtitle";
export const LOCATION_IMAGE = "location-placeholder.jpg";

export const CMS = {
  hero: {
    title: "exactly_what_you_are_looking_for",
  },
};
